import { render } from "./lidaHeader.vue?vue&type=template&id=2bf1bf88"
import script from "./lidaHeader.vue?vue&type=script&lang=js"
export * from "./lidaHeader.vue?vue&type=script&lang=js"

import "./lidaHeader.vue?vue&type=style&index=0&id=2bf1bf88&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__